<div :class="$style.infoFooterContainer">
  <MdTypography v-bind="{tag:'p',variant:'micro1--regular',color:'spirits--700'}"
    data-qa-id="ingestion-dashboard-info-footer">
    {{ $t('pages.inventory_ingestion_hub.dashboard.info-footer') }}
  </MdTypography>
</div>